export const customPreviewImage = "custom-image"

export const MODEL_IMAGES = [
  "/preview-faces/model-0.png",
  "/preview-faces/model-1.png",
  "/preview-faces/model-2.png",
  "/preview-faces/model-3.png",
  "/preview-faces/model-4.png",
]
